import { OTHERS } from 'modules/devices/constants';
import { indexByProp } from 'utils/global';

type FilterParams = Record<string, unknown>;

export const formatFilters = (params: FilterParams, property: string, value: unknown): FilterParams => {
  if (value) {
    if (value === OTHERS) {
      return {
        ...params,
        notExist: [...((params.notExist as string[] | undefined) ?? []), property],
      };
    }
    return {
      ...params,
      [property]: value,
    };
  }
  return params;
};

export const indexValues = <T extends Record<string, unknown>>(
  content: T[],
  field: string,
  emptyValue = ''
): Record<string, T> =>
    indexByProp(
      field,
      content.map(item => (field in item ? item : { ...item, [field]: emptyValue }))
    );
